export const ATTENDANCE_STATUS = {
  NOT_CHECKED: "notChecked",
  PARTIALLY_CANCELLED: "partiallyCancelled",
  CANCELLED: "cancelled",
  CHECKED: "checked",
};

const cancellationStatuses = ["cancelledOnTime", "cancelledLate"];

export function getLessonAttendanceStatus(scheduledLesson = {}) {
  const { lessonRegister } = scheduledLesson;
  if (!lessonRegister) return ATTENDANCE_STATUS.NOT_CHECKED;

  const details = lessonRegister.lessonDetails || {};
  if (details.lessonStatus === "cancelled") return ATTENDANCE_STATUS.CANCELLED;
  if (details.attendanceStatus) return details.attendanceStatus;

  const students = lessonRegister.students || [];
  const hasCancellation = students.some(student => cancellationStatuses.includes(student.participationStatus));
  if (hasCancellation) return ATTENDANCE_STATUS.PARTIALLY_CANCELLED;

  return students.length > 0 ? ATTENDANCE_STATUS.CHECKED : ATTENDANCE_STATUS.NOT_CHECKED;
}

export function isAttendanceChecked(scheduledLesson) {
  return getLessonAttendanceStatus(scheduledLesson) === ATTENDANCE_STATUS.CHECKED;
}

export function isLessonCancelled(scheduledLesson) {
  return getLessonAttendanceStatus(scheduledLesson) === ATTENDANCE_STATUS.CANCELLED;
}

export function hasPartialCancellation(scheduledLesson) {
  return getLessonAttendanceStatus(scheduledLesson) === ATTENDANCE_STATUS.PARTIALLY_CANCELLED;
}
